export default __webpack_public_path__ + "static/media/sec-image.ba8fb909.png";